import { call, put, takeEvery } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { callApi } from "sagas/Api"
import { GET_AGREEMENT_CARDS, storeAgreementCards } from "actions"
import { getAgreementCards } from "apis/AgreementCards"
import { moveToTop } from "locale"

export function* handleGetAgreementCards() {
  yield takeEvery(GET_AGREEMENT_CARDS, execGetAgreementCards)
}

export function* execGetAgreementCards() {
  const { payload, error } = yield call(callApi, getAgreementCards)
  if (payload && !error) {
    yield put(storeAgreementCards(payload))
  } else {
    if (error.message === "invalid token") {
      // リフレッシュトークンが無効な場合
      yield call(DLogin, { prompt: false })
    } else if (error.message === "dauth error") {
      // サーバエラーなどでトークンリフレッシュに失敗した場合
      yield call(moveToTop)
    } else {
      // APIの処理に失敗した場合
      yield call(moveToTop)
    }
  }
}
